import React from 'react';

import {
  CognitoGetCurrentUserAuthStatusDocument,
  useCognitoGetCurrentUserAuthStatusQuery,
} from 'src/api';

type CurrentUserAuthStatusHookParams = {
  queryParams?: Parameters<typeof useCognitoGetCurrentUserAuthStatusQuery>[0];
};

export const useCurrentUserAuthStatus = (params: CurrentUserAuthStatusHookParams = {}) => {
  const { data, loading, variables } = useCognitoGetCurrentUserAuthStatusQuery(params.queryParams);

  const isMfaRequired = React.useMemo(() => {
    return data?.cognitoGetCurrentUserAuthStatus.mfaRequired || false;
  }, [data?.cognitoGetCurrentUserAuthStatus.mfaRequired]);

  const isMfaEnabled = React.useMemo(() => {
    return data?.cognitoGetCurrentUserAuthStatus.mfaEnabled || false;
  }, [data?.cognitoGetCurrentUserAuthStatus.mfaEnabled]);

  const isSsoEnabled = data?.cognitoGetCurrentUserAuthStatus.ssoEnabled || false;

  return {
    isMfaRequired,
    isMfaEnabled,
    isSsoEnabled,
    loading,
    queryDocument: CognitoGetCurrentUserAuthStatusDocument,
    queryVariables: variables,
  };
};
